export default {
  labels: {
    order: 'Pedido',
    customer: 'Cliente',
  },
  tags: {
    new_customer: 'Nuevo cliente',
    loyal_customer: 'Cliente fiel',
  },
};
